/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteMcpGetServerScopes } from "../funcs/remoteMcpGetServerScopes.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteMcpServerScopes } from "../models/components/remotemcpserverscopes.js";
import {
  GetRemoteMcpServerScopesRequest,
  GetRemoteMcpServerScopesSecurity,
} from "../models/operations/getremotemcpserverscopes.js";
import { unwrapAsync } from "../types/fp.js";
export type GetRemoteMcpServerScopesQueryData = RemoteMcpServerScopes;

export function prefetchGetRemoteMcpServerScopes(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetRemoteMcpServerScopesRequest,
  security?: GetRemoteMcpServerScopesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetRemoteMcpServerScopesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetRemoteMcpServerScopesQuery(
  client$: GramCore,
  request: GetRemoteMcpServerScopesRequest,
  security?: GetRemoteMcpServerScopesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetRemoteMcpServerScopesQueryData>;
} {
  return {
    queryKey: queryKeyGetRemoteMcpServerScopes({
      mcpServerId: request.mcpServerId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function getRemoteMcpServerScopesQueryFn(
      ctx,
    ): Promise<GetRemoteMcpServerScopesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteMcpGetServerScopes(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetRemoteMcpServerScopes(
  parameters: {
    mcpServerId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteMcp", "getServerScopes", parameters];
}
